import React, { Component, Suspense } from "react";
import { HashRouter, Route, Routes, useLocation } from "react-router-dom";
import "./scss/style.scss";
import Draft from "./views/pages/draft/Draft";
import TopNavbar from "./views/pages/TopNavbar/TopNavbar";
import MapHotels from "./views/pages/MapHotels/MapHotels";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useState, useEffect } from "react";
import { auth } from "./BackendFirebase/firebaseConfig";
import UserContext from "./BackendFirebase/isLoggedIn";
import AppFooter from "./components/AppFooter";
import Contact from "./views/pages/Contact/Contact";
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./views/pages/login/Login"));
const Register = React.lazy(() => import("./views/pages/register/Register"));
const Aboutus = React.lazy(() => import("./views/pages/aboutus/Aboutus"));
const FAQ = React.lazy(() => import("./views/pages/FAQ/FAQ"));
const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));
//const Contact = React.lazy(() => import("./views/pages/Contact/Contact"));
const MyProfileAWS = React.lazy(() =>
  import("./views/pages/myprofile/MyProfileAWS")
);
const VerifyEmail = React.lazy(() =>
  import("./views/pages/verifyemail/VerifyEmail")
);
const ConfirmEmail = React.lazy(() =>
  import("./views/pages/passwordreset/ConfirmEmail")
);
const ResetPassword = React.lazy(() =>
  import("./views/pages/passwordreset/ResetPassword")
);

const LandingPage = React.lazy(() =>
  import("./views/pages/landingpage/LandingPage")
);

const BookShower = React.lazy(() => import("./BackendAWS/BookPage"));

// Email App
const EmailApp = React.lazy(() => import("./views/apps/email/EmailApp"));

// FooterWithCondition component checks the current route using useLocation().
// If the path is not "/map-hotels", it renders the AppFooter component.
// Otherwise, it renders nothing (returns null).
const FooterWithCondition = () => {
  const location = useLocation();
  if (location.pathname !== "/map-hotels") {
    return <AppFooter />;
  }
  return null;
};

const App = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((userAuth) => {
      let user = null;
      if (userAuth) {
        user = {
          email: userAuth.email,
          uid: userAuth.uid,
          emailVerified: userAuth.emailVerified,
        };
      }
      setUser(user);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <>
      <UserContext.Provider value={user}>
        <HashRouter>
          <Suspense fallback={loading}>
            <TopNavbar />
            <Routes>
              <Route exact path="/" element={<LandingPage />} />
              <Route exact path="/sign-in" element={<Login />} />
              <Route exact path="/sign-up" element={<Register />} />
              <Route path="/book-shower/:hotelName" element={<BookShower />} />

              <Route exact path="/draft" element={<Draft />} />
              <Route exact path="/about" element={<Aboutus />} />
              <Route exact path="/map-hotels" element={<MapHotels />} />

              <Route path="/404" element={<Page404 />} />
              <Route path="/500" element={<Page500 />} />
              <Route path="/apps/email/*" element={<EmailApp />} />
              <Route path="/resource/*" element={<DefaultLayout />} />
              <Route path="/myprofileAWS" element={<MyProfileAWS />} />
              <Route path="/verifyemail" element={<VerifyEmail />} />
              <Route path="/confirm-email" element={<ConfirmEmail />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/Contact" element={<Contact />} />
            </Routes>
            {/*Use the FooterWithCondition component to conditionally render the AppFooter based on the route. */}
            <FooterWithCondition />
          </Suspense>
        </HashRouter>
      </UserContext.Provider>
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default App;
